import { data } from '../../svg/Frame/data';
import { makeIcon } from '../makeIcon';

export const Frame = makeIcon(data, 'frame', 'Frame');

export default Frame;
